import React, { Component } from "react";

export class Inicio extends Component {
  render() {
    return (
      <div className="maintest">
        <section class="hero">
          <div class="heroheader">
            <div class="hero-content">
              <h1 class="slogan">Conecta, Comparte y Gana</h1>
              <p>
                Únete a nuestra comunidad de streaming en vivo. Interactúa con
                creadores, haz nuevos amigos y gana dinero real con tus
                transmisiones.
              </p>
            </div>
            <div class="hero-visual">
              <img src="img/allmodel.png" alt="Class" />
            </div>
          </div>
        </section>

        <section class="features">
          <div class="container">
            <h2 class="section-title">Características que te harán sonreír</h2>
            <div class="features-grid">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <h3 class="feature-title">Privacidad Total</h3>
                <p>
                  Controla tu información personal. Oculta tu edad y ubicación
                  para mayor tranquilidad mientras disfrutas de la plataforma.
                </p>
              </div>

              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fas fa-ban"></i>
                </div>
                <h3 class="feature-title">Protección Anticapturas</h3>
                <p>
                  Sistema avanzado que evita cualquier captura de pantalla
                  durante las transmisiones, protegiendo tu contenido y
                  privacidad.
                </p>
              </div>

              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fas fa-bolt"></i>
                </div>
                <h3 class="feature-title">Tecnología Moderna</h3>
                <p>
                  Transmisiones directas entre usuarios sin intermediarios.
                  Conexiones más rápidas y de mayor calidad sin depender de
                  servidores.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="fun">
          <div class="container">
            <div class="fun-content">
              <div class="fun-text">
                <h2>Entra y diviértete</h2>
                <p>
                  Conoce gente nueva de forma totalmente gratuita y al azar.
                  Nuestra plataforma está diseñada para conectar personas con
                  intereses similares de manera espontánea y divertida.
                </p>
                <p>
                  Disfruta de transmisiones en vivo de la más alta calidad, sin
                  interrupciones. La experiencia depende únicamente de las
                  conexiones de los usuarios, garantizando autenticidad en cada
                  interacción.
                </p>
                <p>
                  Desde charlas casuales hasta shows en vivo, siempre
                  encontrarás contenido que te hará sonreír y pasar un buen
                  rato.
                </p>
              </div>
              <div class="fun-visual">
                <div class="fun-animation">
                  <i class="fas fa-laugh-beam"></i>
                  <span>¡Diviértete!</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="community">
          <div class="container">
            <div class="community-content">
              <div class="community-visual">
                <div class="community-stats">
                  <div class="stat-card">
                    <div class="stat-number">500K+</div>
                    <div class="stat-text">Usuarios Activos</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-number">50+</div>
                    <div class="stat-text">Países</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-number">10K+</div>
                    <div class="stat-text">Transmisiones Diarias</div>
                  </div>
                  <div class="stat-card">
                    <div class="stat-number">24/7</div>
                    <div class="stat-text">Soporte</div>
                  </div>
                </div>
              </div>
              <div class="fun-text">
                <h2>Únete a nuestra comunidad global</h2>
                <p>
                  Conecta con personas de todo el mundo en tiempo real. Nuestra
                  plataforma une culturas, idiomas y pasiones a través de
                  transmisiones en vivo.
                </p>
                <p>
                  Forma parte de una comunidad vibrante donde cada día se crean
                  nuevas amistades y se comparten experiencias únicas.
                </p>
                <p>
                  Descubre talentos ocultos, aprende de otras culturas y expande
                  tu círculo social de manera segura y entretenida.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="monetization" id="ganancias">
          <div class="container">
            <div class="monetization-content">
              <div class="monetization-text">
                <h2>Gana Dinero Real con tus Streams</h2>
                <p>
                  En CandyCam, los creadores pueden monetizar su contenido a
                  través de regalos virtuales que se convierten en dinero real.
                </p>
                <p>
                  Cada regalo que recibes de tus espectadores tiene un valor en
                  gemas, que puedes canjear por dinero.
                </p>
                <ul class="features-list">
                  <li>
                    <i class="fas fa-check-circle"></i> Recibe regalos de tus
                    espectadores
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Las gemas se convierten
                    en dinero real
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Retiros seguros
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Sistema de propinas
                    integrado
                  </li>
                </ul>
              </div>
              <div class="monetization-visual">
                <div class="gift-animation">
                  <i class="fas fa-gift"></i>
                  <span>¡Regalos = Dinero!</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="referral" id="referidos">
          <div class="container">
            <div class="referral-content">
              <div style={{ display: "block" }}>
                <div class="referral-visual">
                  <div class="referral-card">
                    <div class="referral-percent">10%</div>
                    <div class="referral-text">
                      de las games que recibe cada usuario que invites
                    </div>
                  </div>
                </div>

                <div class="referral-visual">
                  <div class="referral-card">
                    <div class="referral-percent">10%</div>
                    <div class="referral-text">
                      de las games que compre cada usuario que invites
                    </div>
                  </div>
                </div>
              </div>
              <div class="monetization-text">
                <h2>Programa de Referidos</h2>
                <p>
                  Invita a otros usuarios a unirse a CandyCam con tu código y
                  gana el 10% de las games que ganen o compren.
                </p>
                <p>
                  Cada vez que un usuario que invitaste recibe regalos durante
                  sus transmisiones, tú recibes automáticamente el 10% del valor
                  en gemas que ellos recibieron.
                </p>

                <p>
                  Cada vez que un usuario que invitaste compre Gemas dentro del
                  app, tú recibes automáticamente el 10% del valor en gemas que
                  ellos compraron.
                </p>
                <ul class="features-list">
                  <li>
                    <i class="fas fa-check-circle"></i> Gana por cada creador
                    que invites
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Comisión del 10% de por
                    vida
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Sin límite de referidos
                  </li>
                  <li>
                    <i class="fas fa-check-circle"></i> Pagos automáticos sin
                    intermediarios
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section class="monetization" id="descarga">
          <div class="container">
            <div>
              <h2>¿Estás listo para ganar dinero?</h2>
              <h3>Descarga ya nuestra app</h3>
            </div>

            <div class="contenedor-flex">
              <a
                href="https://candycam.me/down/candycam.apk"
                class="btn btn-hero"
                download="candycam.apk"
              >
                <i class="fas fa-download"></i> Descargar para Android
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Inicio;
